import type { TranslationKey } from './en.js';

export const es: Partial<Record<TranslationKey, string>> = {
  'app.name': 'Volt',

  'section.chat': 'Chat',
  'section.image': 'Imágenes',
  'section.video': 'Vídeo',
  'section.video2': 'Vídeo 2 (Marketing Studio)',
  'section.character': 'Personaje',
  'section.audio': 'Música y audio',
  'section.voice': 'Voz',
  'section.design': 'Diseño',

  'common.loading': 'Cargando…',
  'common.error': 'Algo salió mal',
  'common.retry': 'Reintentar',
  'common.refresh': 'Actualizar',
  'common.cancel': 'Cancelar',
  'common.confirm': 'Confirmar',
  'common.save': 'Guardar',
  'common.close': 'Cerrar',
  'common.delete': 'Eliminar',
  'common.create': 'Crear',
  'common.apply': 'Aplicar',
  'common.offline': 'Sin conexión — mostrando datos guardados',
  'common.you': 'Tú',
  'common.assistant': 'Asistente',
  'common.empty': 'Aún no hay nada aquí',
  'common.back': 'Atrás',

  'auth.loading': 'Iniciando sesión…',
  'auth.openInTelegram': 'Ábreme dentro de Telegram',
  'auth.openInTelegramHint':
    'Volt funciona como una Mini App de Telegram. Ábrela desde tu chat con el bot para iniciar sesión.',
  'auth.retry': 'Reintentar',
  'auth.error': 'No se pudo iniciar sesión',
  'auth.devHint': 'Vista de desarrollo — sin datos de Telegram.',

  'topbar.menu': 'Abrir menú',
  'topbar.settings': 'Ajustes',
  'topbar.balance': 'Saldo',

  'directChat.open': 'Abrir chat privado',
  'pager.chat': 'Chat',
  'pager.label': 'Cambiar de pantalla',
  'directChat.title': 'Chat personal',
  'directChat.yourId': 'Tu ID: {id}',
  'directChat.addPlaceholder': 'ID público o @usuario de Telegram',
  'directChat.addFriend': 'Añadir amigo',
  'directChat.addSelf': 'No puedes agregarte a ti mismo como amigo.',
  'directChat.friends': 'Amigos',
  'directChat.noFriends':
    'Aún no tienes amigos. Añade a alguien con su ID público o @usuario de Telegram.',
  'directChat.selectFriend': 'Elige un amigo para abrir la conversación.',
  'directChat.noMessages': 'Aún no hay mensajes. ¡Saluda!',
  'directChat.messagePlaceholder': 'Escribe un mensaje…',
  'directChat.send': 'Enviar mensaje',
  'directChat.notFound':
    'No se encontró ningún usuario con ese ID o nombre de usuario de Telegram.',
  'directChat.noPermission': 'Solo puedes escribir a un amigo.',
  'directChat.addError':
    'Comprueba el ID o el nombre de usuario; quizá ya añadiste a esta persona.',
  'directChat.error': 'No se pudo cargar el chat. Inténtalo de nuevo.',
  'directChat.openDrawer': 'Abrir conversaciones',
  'directChat.chats': 'Conversaciones',
  'directChat.groups': 'Grupos',
  'directChat.newGroup': 'Nuevo grupo',
  'directChat.createGroup': 'Crear grupo',
  'directChat.groupName': 'Nombre del grupo',
  'directChat.selectMembers': 'Selecciona miembros ({count}/50 incluyéndote)',
  'directChat.memberCount': '{count} miembros',
  'directChat.messages': 'Mensajes',
  'directChat.messageActions': 'Acciones del mensaje',
  'directChat.reply': 'Responder',
  'directChat.replyingTo': 'Respondiendo a {name}',
  'directChat.forward': 'Reenviar',
  'directChat.forwarded': 'Reenviado',
  'directChat.chooseDestination': 'Elige una conversación para reenviar',
  'directChat.deleteForMe': 'Eliminar para mí',
  'directChat.deleteForEveryone': 'Eliminar para todos',
  'directChat.deleteForEveryoneConfirm': '¿Eliminar este mensaje para todos en el chat?',
  'directChat.aiAttribution': 'Inteligencia Artificial',
  'directChat.aiToggleEnabled': 'Respuestas de IA activadas',
  'directChat.aiToggleDisabled': 'Respuestas de IA desactivadas',
  'directChat.aiGenerating': 'La IA está respondiendo…',
  'directChat.aiGenerationError': 'Error al generar la respuesta de la IA: {error}',
  'directChat.aiChooseModel': 'Elegir modelo de IA',
  'directChat.aiLongPressHint': 'Mantén presionado para elegir modelo',
  'directChat.sent': 'Enviado',
  'directChat.delivered': 'Entregado',
  'directChat.read': 'Leído',

  'sidebar.title': 'Chats',
  'sidebar.newChat': 'Nuevo chat',
  'sidebar.search': 'Buscar',
  'sidebar.searchPlaceholder': 'Buscar chats…',
  'sidebar.projects': 'Proyectos',
  'sidebar.newProject': 'Nuevo proyecto',
  'sidebar.noConversations': 'Aún no hay conversaciones',
  'sidebar.archived': 'Archivados',
  'sidebar.showArchived': 'Mostrar archivados',
  'sidebar.hideArchived': 'Ocultar archivados',
  'sidebar.pinned': 'Fijados',
  'sidebar.today': 'Hoy',
  'sidebar.yesterday': 'Ayer',
  'sidebar.previous7Days': 'Últimos 7 días',
  'sidebar.previous30Days': 'Últimos 30 días',
  'sidebar.older': 'Anteriores',

  'menu.rename': 'Renombrar',
  'menu.pin': 'Fijar',
  'menu.unpin': 'Desfijar',
  'menu.archive': 'Archivar',
  'menu.unarchive': 'Desarchivar',
  'menu.addToFolder': 'Agregar a carpeta',
  'menu.moveUp': 'Subir',
  'menu.moveDown': 'Bajar',
  'menu.delete': 'Eliminar',
  'menu.deleteTitle': '¿Eliminar chat?',
  'menu.deleteConfirm': 'Esta conversación y sus mensajes se eliminarán permanentemente.',

  'project.name': 'Nombre del proyecto',
  'project.description': 'Descripción',
  'project.systemPrompt': 'Instrucciones personalizadas',
  'project.systemPromptHint': 'Estas instrucciones se envían al modelo en cada chat del proyecto.',
  'project.create': 'Crear proyecto',
  'project.empty': 'Aún no hay proyectos',

  'composer.placeholder': 'Mensaje para Volt…',
  'composer.imagePlaceholder': 'Describe la imagen que quieres…',
  'composer.videoPlaceholder': 'Describe el vídeo que quieres…',
  'composer.characterPlaceholder': 'Describe el personaje…',
  'composer.audioPlaceholder': 'Describe la música o el audio…',
  'composer.voicePlaceholder': 'Texto para convertir en voz…',

  'character.tabSoulId': 'Soul ID',
  'character.tabCharacter': 'Personaje',
  'character.tabSoulCast': 'Soul Cast',
  'character.tabAiInfluencer': 'Influencer IA',
  'character.soulIdTitle': 'Entrenar Soul ID',
  'character.characterTitle': 'Personajes',
  'character.soulCastTitle': 'Soul Cast',
  'character.aiInfluencerTitle': 'Influencers IA',
  'character.name': 'Nombre',
  'character.description': 'Descripción',
  'character.bio': 'Biografía',
  'character.style': 'Estilo',
  'character.scene': 'Escena',
  'character.prompt': 'Prompt',
  'character.referenceImages': 'URLs de imágenes de referencia, una por línea',
  'character.pickSoulId': 'Selecciona un Soul ID',
  'character.pickCharacter': 'Selecciona un personaje',
  'character.noSoulLinked': 'Sin Soul ID vinculado',
  'character.scopeLabel': 'Qué crear',
  'character.scopeHead': 'Cabeza',
  'character.scopeFullBody': 'Cuerpo completo',
  'character.scopeHeadHint': 'Los primeros planos del rostro desde distintos ángulos funcionan mejor.',
  'character.scopeFullBodyHint': 'Añade fotos de cuerpo entero para construir todo el cuerpo.',
  'character.scopeBadgeHead': 'Cabeza',
  'character.scopeBadgeFullBody': 'Cuerpo completo',
  'character.model3dCreate': 'Crear modelo 3D',
  'character.model3dView': 'Ver en 3D',
  'character.model3dBuilding': 'Creando el modelo 3D… tarda unos minutos.',
  'character.model3dFailed': 'No se pudo crear el modelo 3D',
  'character.model3dRetry': 'Reintentar',
  'character.model3dStarted': 'Se está creando el modelo 3D',
  'character.model3dStage': 'Visor del modelo 3D',
  'character.model3dLoading': 'Cargando el modelo…',
  'character.model3dError': 'No se pudo abrir el modelo 3D.',
  'character.model3dUnsupported': 'Tu dispositivo no admite 3D (WebGL).',
  'character.model3dHint': 'Arrastra para girar · pellizca o usa la rueda para acercar',
  'character.model3dReset': 'Restablecer vista',
  'character.model3dAutoRotate': 'Giro automático',
  'character.soulIdPhotoHint': 'Sube de 5 a 20 fotos de referencia.',
  'character.soulIdPhotoCount': 'Elige entre 5 y 20 fotos.',
  'character.soulIdUploadFailed': 'No se pudieron subir las fotos. Inténtalo de nuevo.',
  'character.createSoulId': 'Crear Soul ID',
  'character.createCharacter': 'Crear personaje',
  'character.createAiInfluencer': 'Crear influencer IA',
  'character.generateSoulCast': 'Generar Soul Cast',
  'character.generateContent': 'Generar contenido',
  'character.status.training': 'Entrenando',
  'character.status.ready': 'Listo',
  'character.status.failed': 'Falló',
  'composer.send': 'Enviar',
  'composer.stop': 'Detener',
  'composer.attach': 'Adjuntar archivos',
  'composer.attachTitle': 'Agregar archivo adjunto',
  'composer.attachAllPhotos': 'Todas las fotos',
  'composer.attachCamera': 'Cámara',
  'composer.attachPhotos': 'Fotos',
  'composer.attachFiles': 'Archivos',
  'composer.attachFilesHint': 'Fotos sin compresión',
  'composer.attachToFolder': 'Agregar a carpeta',
  'composer.voiceInput': 'Entrada de voz',
  'composer.listening': 'Escuchando…',
  'composer.thinking': 'Pensando…',
  'composer.model': 'Modelo',
  'composer.selectModel': 'Elegir modelo',
  'composer.unavailable': 'No disponible',
  'composer.estimate': '≈ {price}',
  'composer.topUpHint': 'Recarga tu saldo hasta {amount} para seguir',
  'composer.generate': 'Generar',

  'message.copy': 'Copiar',
  'message.copied': 'Copiado',
  'message.share': 'Compartir',
  'message.regenerate': 'Regenerar',
  'message.edit': 'Editar',
  'message.save': 'Guardar y reenviar',
  'message.up': 'Buena respuesta',
  'message.down': 'Mala respuesta',
  'message.usage': '{model} · {input} ent · {output} sal · {cost}',
  'message.usageNoModel': '{input} ent · {output} sal · {cost}',
  'message.failed': 'Falló la generación',
  'message.reasoningTitle': 'Proceso de análisis',
  'conversation.pinnedBadge': 'Chat fijado',

  // TODO: translate share keys
  'share.button': 'Share',
  'share.createLink': 'Create link',
  'share.copyLink': 'Copy link',
  'share.copied': 'Copied!',
  'share.revoke': 'Revoke link',
  'share.revokeConfirm':
    'Are you sure you want to revoke this link? Anyone with the link will no longer be able to access it.',
  'share.title': 'Share conversation',
  'share.sharedBy': 'Shared snapshot',
  'share.notFound': 'This link has expired or been revoked.',
  'share.openApp': 'Open Volt',
  'share.loading': 'Loading…',
  'share.sendToChat': 'Enviar al chat',
  'share.noDestinations': 'No hay chats ni grupos disponibles',
  'share.sentSuccess': '¡Enviado!',
  'share.sending': 'Enviando…',
  'share.loadingDestinations': 'Cargando chats…',
  'artifact.preview': 'Vista previa',
  'artifact.code': 'Código',
  'artifact.open': 'Abrir artefacto',
  'artifact.export': 'Exportar',
  'artifact.download': 'Descargar',
  'artifact.copy': 'Copiar',
  'artifact.edit': 'Editar',
  'artifact.close': 'Cerrar',
  'artifact.fullscreen': 'Pantalla completa',

  'job.status': 'Estado',
  'job.pending': 'En cola',
  'job.processing': 'Procesando…',
  'job.done': 'Listo',
  'job.failed': 'Error',
  'job.cancelled': 'Cancelado',
  'job.result': 'Resultado',
  'job.empty': 'Aún no hay generaciones',
  'job.actions': 'Acciones',
  'job.favoriteAdd': 'Añadir a favoritos',
  'job.favoriteRemove': 'Quitar de favoritos',
  'job.favorited': 'Favorito',
  'job.regenerate': 'Regenerar',
  'job.viewPrompt': 'Ver aviso',
  'job.promptTitle': 'Aviso',
  'job.download': 'Descargar',
  'job.deleteTitle': '¿Eliminar generación?',
  'job.deleteConfirm': 'Esta generación se eliminará de forma permanente.',

  'design.subtitle': 'Abre una herramienta de diseño en una ventana nueva',
  'design.open': 'Abrir',

  'settings.title': 'Ajustes',
  'settings.profile': 'Perfil',
  'settings.appearance': 'Apariencia',
  'settings.theme': 'Tema',
  'settings.themeLight': 'Claro',
  'settings.themeDark': 'Oscuro',
  'settings.themeSystem': 'Sistema',
  'settings.language': 'Idioma',
  'settings.balance': 'Saldo',
  'settings.topup': 'Recargar',
  'settings.topupAmount': 'Importe, ₽',
  'settings.topupSubmit': 'Recargar saldo',
  'settings.transactions': 'Historial de transacciones',
  'settings.noTransactions': 'Aún no hay transacciones',
  'settings.loadMore': 'Cargar más',
  'settings.notifications': 'Notificaciones',
  'settings.notificationsHint': 'Avisar cuando terminen las generaciones',
  'settings.data': 'Tus datos',
  'settings.exportData': 'Exportar mis datos',
  'settings.deleteAccount': 'Eliminar cuenta',
  'settings.deleteAccountTitle': '¿Eliminar tu cuenta?',
  'settings.deleteAccountConfirm':
    'Esto elimina permanentemente tu cuenta, conversaciones y saldo. No se puede deshacer.',
  'settings.username': 'Usuario',
  'settings.name': 'Nombre',

  'admin.title': 'Admin',
  'admin.stats': 'Estadísticas',
  'admin.users': 'Usuarios',
  'admin.settings': 'Ajustes de la plataforma',
  'admin.markup': 'Margen, %',
  'admin.usdRub': 'Tasa USD → RUB',
  'admin.minBalance': 'Saldo mínimo, ₽',
  'admin.contextLimit': 'Mensajes de contexto',
  'admin.models': 'Precios de modelos',
  'admin.price': 'Precio',
  'admin.revenue': 'Ingresos',
  'admin.cost': 'Coste del proveedor',
  'admin.margin': 'Margen',
  'admin.activeUsers': 'Activos (24 h)',
  'admin.failedJobs': 'Tareas fallidas',
  'admin.ban': 'Bloquear',
  'admin.unban': 'Desbloquear',
  'admin.adjustBalance': 'Ajustar saldo',
  'admin.reason': 'Motivo',
  'admin.amount': 'Importe, ₽',
  'admin.errorHistory': 'Historial de errores',
  'admin.errorsEmpty': 'Aún no hay errores registrados.',

  'error.UNAUTHORIZED': 'Tu sesión expiró. Vuelve a abrir la app.',
  'error.FORBIDDEN': 'No tienes acceso a esto.',
  'error.USER_BANNED': 'Tu cuenta ha sido suspendida.',
  'error.NOT_FOUND': 'No encontrado.',
  'error.RATE_LIMITED': 'Demasiadas solicitudes. Ve más despacio.',
  'error.DAILY_LIMIT_EXCEEDED': 'Límite diario alcanzado. Inténtalo mañana.',
  'error.INSUFFICIENT_BALANCE': 'Saldo insuficiente para esta solicitud.',
  'error.BELOW_MIN_BALANCE': 'Tu saldo está por debajo del mínimo.',
  'error.MODEL_UNAVAILABLE': 'Este modelo no está disponible ahora.',
  'error.MODEL_NOT_SUPPORTED': 'Este modelo no es compatible aquí.',
  'error.PROVIDER_ERROR': 'El proveedor devolvió un error.',
  'error.PROVIDER_TIMEOUT': 'El proveedor tardó demasiado.',
  'error.CONTEXT_TOO_LARGE': 'Esta conversación es demasiado larga para el modelo.',
  'error.PAYMENT_INVALID': 'No se pudo procesar el pago.',
  'error.INTERNAL': 'Error del servidor. Inténtalo de nuevo.',
  'error.network': 'Error de red. Comprueba tu conexión.',
  'error.streamInterrupted': 'Conexión interrumpida. La respuesta se recuperó del servidor.',
  'error.generic': 'Algo salió mal.',
};
